import { createRouter, createWebHistory } from "vue-router";
import Template from "../views/Vega.vue";

//------UTILS
import { isUserTechnician } from "@/utils/auth/verifyUserLogged.js";

const routes = [
  {
    path: "/",
    name: "index",
   
    redirect: (to) => {
      if (localStorage.getItem("vega@token") == null) {
        return {
          name: "login",
        };
      }
      if (isUserTechnician()) {
        return { name: "template" };
      } else {
        return { name: "config" };
      }
    },
  },
  {
    path: "/disabled",
    name: "disabled",
    component: () => import("@/views/DisabledPage.vue"),
  },
  {
    path: "/auth",
    name: "auth",
    redirect: { path: "/login" },
    beforeEnter: (to, from, next) => {
     
      localStorage.getItem("vega@token") ? next(from) : next();
    },
    children: [
      {
        path: "/login",
        name: "login",
        component: () => import("../views/Login.vue"),
      },
      {
        path: "/sigin-user",
        name: "sigin-user",
        component: () => import("@/pages/contingencyConfig/AddUser.vue"),
      },
      {
        path: "/reset-password",
        name: "reset-password",
        component: () => import("@/pages/contingencyConfig/ResetPassword.vue"),
      },
    ],
  },
  {
    path: "/config",
    name: "config",
    redirect: { path: "/config-history" },
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem("vega@token") == null) {
        next("/login");
      }
      if (isUserTechnician()) {
        next();
      } else {
        next("/template");
      }
    },
    children: [
      {
        path: "/config-history",
        name: "config-history",
        component: () =>
          import("@/pages/contingencyConfig/HistoryContingency.vue"),
      },
      {
        path: "/config-contingency",
        name: "config-contingency",
        component: () =>
          import("@/pages/contingencyConfig/ConfigAccredited.vue"),
      },
      {
        path: "/enable-contingency",
        name: "enable-contingency",
        component: () =>
          import("@/pages/contingencyConfig/EnableContingency.vue"),
      },
      {
        path: "/register-user",
        name: "register-user",
        component: () => import("@/pages/contingencyConfig/RegisterUser.vue"),
      },
    ],
  },
  {
    path: "/template",
    name: "template",
    component: Template,
    redirect: { path: "/service-history" },
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem("vega@token") == null) {
        next("/login");
      }
      if (isUserTechnician()) {
        next("/config");
      } else {
        next();
      }
    },
    children: [
      {
        path: "/service-history",
        name: "service-history",
        component: () => import("@/pages/ServiceHistory.vue"),
      },
      {
        path: "/active-user",
        name: "active-user",
        component: () => import("@/pages/ActiveUser.vue"),
      },
      {
        path: "/generate-os",
        name: "generate-os",
        component: () => import("@/pages/generateOs/GenerateOsList.vue"),
      },
      {
        path: "/create-os/:os_type/:name_type/",
        name: "create-os",
        component: () => import("@/pages/generateOs/FormGenerateOs.vue"),

      },
      {
        path: "/type-service",
        name: "type-service",
        component: () => import("@/pages/TypeService.vue"),
      },
      {
        path: "/view-datails-contract-os:contract_number",
        name: "view-datails-contract-os",
        component: () => import("@/pages/ViewDatailsOsContract.vue"),
      },
      {
        path: "/low-production/:type_attendance",
        name: "low-production",
        component: () => import("@/pages/TabulationsPages/LowProduction.vue"),
      },
      {
        path: "/generate-ocurrence-",
        name: "generate-ocurrence",
        component: () =>
          import("@/pages/generateOccurrence/handleOcurrence.vue"),
      },
      {
        path: "/ocurrence-fix-address",
        name: "ocurrence-fix-address",
        component: () =>
          import("@/pages/generateOccurrence/GenerateOcurrence.vue"),
      },
      {
        path: "/low-production-without-movimentation/:type_attendance",
        name: "low-production-without-movimentation",
        component: () =>
          import(
            "@/pages/TabulationsPages/LowProductionWithoutMovimentation.vue"
          ),
      },
      {
        path: "/generate-clearance",
        name: "generate-clearance",
        component: () =>
          import("@/pages/TabulationsPages/GenerateClearanceOs.vue"),
      },
      {
        path: "/confirmation-sms-leader",
        name: "confirmation-sms-leader",
        component: () => import("@/pages/ConfirmationSMSLeader.vue"),
      },
      {
        path: "/special-codes",
        name: "special-codes",
        component: () => import("@/pages/SpecialCode/SpecialCodesList.vue"),
      },
      {
        path: "/create-special-codes/:os_type/:name_type/",
        name: "create-special-codes",
        component: () => import("@/pages/SpecialCode/GenerateFormSpecialCodes.vue"),
      },
      {
        path: "/finish-activity",
        name: "finish-activity",
        component: () => import("@/pages/FinishActivity/OptionsList.vue"),
      },
      {
        path: "/create-finish-activity/:os_type/:name_type/",
        name: "create-finish-activity",
        component: () => import("@/pages/FinishActivity/GenerateFormFinishActivity.vue"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
